import { Expose } from 'class-transformer';
import { Model } from '../../shared-features/models/model';

export class DriversCounts extends Model {
    @Expose() totalFreelanceDriversCount: number;
    @Expose() totalFleetsDriversCount: number;
    @Expose() lastRefreshTime:Date;
}
